const prod = {
    url: {
        // The admin SPA is served by its own API host, so use whatever host it was loaded from
        // (admin.wgc.gg, or the *.azurewebsites.net name).
        BASE_URL: typeof window !== "undefined" ? window.location.origin : "https://admin.wgc.gg",
    }
};

const stage = {
    url: {
        BASE_URL: "http://admin-worldgolfchallenge-stage.azurewebsites.net",
    }

};

const test = {
    url: {
        BASE_URL: "https://admin-worldgolfchallenge-test-2.azurewebsites.net",
    },
    logrocket: {
        key: "i4mmqc/wgc-test"
    }
};

const dev = {
        url: {
        BASE_URL: "https://localhost:50926",
    }
};

export const config = process.env.NODE_ENV === "development" ? (process.env.REACT_APP_ENV === "test" ? test : dev) : (process.env.REACT_APP_ENV === "stage" ? stage : (process.env.REACT_APP_ENV === "test" ? test : prod));